import { getStore } from '~/mobx/AppStore';

/**
 * Cancels candidate edit/create mode and resets the detail form.
 * Optionally skips reloading the candidate list.
 * @param options.skipCandidateListReload If true, does not reload the candidate list.
 */
const cancelEdit = (options?: { skipCandidateListReload?: boolean }) => {
    const { candidateStore } = getStore();
    candidateStore.setIsCreateMode(false);
    candidateStore.setIsEditMode(false);
    candidateStore.resetDetailForm();
    candidateStore.setFieldsKeyWithIssues([]);
    if (options?.skipCandidateListReload) return;
    candidateStore.getCandidateListByRegionId(candidateStore.selectedRegionId);
};

export default cancelEdit;
